<div 
    [ngClass]="{ 
        'at-risk-abroad': risk === RISK_CATEGORY.AtRiskAbroad
    }"
    class="network-warning"
>
    <i class="pi pi-exclamation-triangle network-warning__icon"></i>

    <div class="network-warning__column-right">
        <ng-container *ngIf="risk === RISK_CATEGORY.AtRiskAbroad">
            <span class="description">
                {{ 'networkWarning.thisDevice' | translate }} <b>{{ 'networkWarning.stopWorking' | translate }}</b> {{ 'networkWarning.date' | translate }}
            </span>
            <a class="link" href="https://5g.tekom.pl/" target="_blank">
                {{ 'networkWarning.helpBtn' | translate }}
            </a>
        </ng-container>
    </div>
</div>
